module.exports = __webpack_public_path__ + "img/astral-txt_14.fb3bc620.svg";